import React from 'react';

function MemoryInfo({ memory, formatBytes }) {
  if (!memory) return null;
  const total = Number(memory.total || 0);
  const free = Number(memory.free || 0);
  const used = memory.used || {};

  return (
    <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
      <h3 style={{ color: '#e5e7eb', marginTop: 0, marginBottom: 12, fontSize: 18 }}>Memory</h3>
      <div style={{ display: 'grid', gap: 8 }}>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Total</div>
          <div style={{ color: '#e5e7eb' }}>{formatBytes(total)}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Free</div>
          <div style={{ color: '#e5e7eb' }}>
            {formatBytes(free)} {total > 0 ? `(${((free / total) * 100).toFixed(1)}%)` : ''}
          </div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Used (RSS)</div>
          <div style={{ color: '#e5e7eb' }}>
            {formatBytes(used.rss || 0)} {total > 0 ? `(${(((used.rss || 0) / total) * 100).toFixed(1)}%)` : ''}
          </div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Heap Total</div>
          <div style={{ color: '#e5e7eb' }}>{formatBytes(used.heapTotal || 0)}</div>
        </div>
        <div>
          <div style={{ color: '#9ca3af', fontSize: 14 }}>Heap Used</div>
          <div style={{ color: '#e5e7eb' }}>{formatBytes(used.heapUsed || 0)}</div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(MemoryInfo);
